import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ServiceCoverage from './pages/ServiceCoverage';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import FAQ from './pages/FAQ';
import CancellationPolicy from './pages/policies/CancellationPolicy';
import RefundPolicy from './pages/policies/RefundPolicy';
import PrivacyPolicy from './pages/policies/PrivacyPolicy';
import TermsConditions from './pages/policies/TermsConditions';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/service-coverage" element={<ServiceCoverage data-id="element-8" />} data-id="element-7" />
            <Route path="/about-us" element={<AboutUs data-id="element-10" />} data-id="element-9" />
            <Route path="/contact-us" element={<ContactUs data-id="element-12" />} data-id="element-11" />
            <Route path="/faq" element={<FAQ data-id="element-14" />} data-id="element-13" />
            <Route path="/cancellation-policy" element={<CancellationPolicy data-id="element-16" />} data-id="element-15" />
            <Route path="/refund-policy" element={<RefundPolicy data-id="element-18" />} data-id="element-17" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-20" />} data-id="element-19" />
            <Route path="/terms-conditions" element={<TermsConditions data-id="element-22" />} data-id="element-21" />
          </Routes>
        </main>
        <Footer data-id="element-23" />
      </div>
    </Router>;
}